import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import CButton from '@/components/ui/CButton'
import qrcode from '@/assets/images/qrcode.jpg'
import cosmosHome from '@/assets/images/cosmos-home.svg'
import './index.less'

const CONTACT_EMAIL = 'Shaun.he@cosmos.ag'

// 工信部 ICP 备案号，须在网站底部展示并链接至工信部备案管理系统
const ICP_NUMBER = '苏ICP备2024087337号-1'
const ICP_LINK = 'https://beian.miit.gov.cn/'

const Footer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleContact = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`
  }

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__cols">
            <div className="footer__col footer__col--grouped">
              <div className="footer__group">
                <span className="footer__col-title">
                  {t('footer.customerSuccessTitle')}
                </span>
                <button
                  className="footer__link"
                  onClick={() => navigate('/')}
                >
                  {t('nav.customerSuccess')}
                </button>
              </div>

              <div className="footer__group">
                <span className="footer__col-title">
                  {t('footer.solutionsTitle')}
                </span>
                <div className="footer__group-links">
                  <button
                    className="footer__link"
                    onClick={() => navigate('/solutions/smart-labor-performance')}
                  >
                    {t('solutions.smartLaborPerformance')}
                  </button>
                  <button
                    className="footer__link"
                    onClick={() => navigate('/solutions/yield-intelligence')}
                  >
                    {t('solutions.yieldIntelligence')}
                  </button>
                  <button
                    className="footer__link"
                    onClick={() => navigate('/solutions/harvest-management')}
                  >
                    {t('solutions.harvestManagement')}
                  </button>
                </div>
              </div>
            </div>

            <div className="footer__col">
              <span className="footer__col-title">
                {t('footer.partnerTitle')}
              </span>
              <button
                className="footer__link"
                onClick={() => navigate('/partners')}
              >
                {t('nav.partnerEcosystem')}
              </button>
            </div>

            <div className="footer__col">
              <span className="footer__col-title">
                {t('footer.contactTitle')}
              </span>
              <a
                className="footer__link"
                href={`mailto:${CONTACT_EMAIL}`}
              >
                {CONTACT_EMAIL}
              </a>
              <CButton shape="pill" size="md" arrow="circle" onClick={handleContact}>
                {t('nav.contactUs')}
              </CButton>
            </div>
          </div>

          <div className="footer__qr">
            <img src={qrcode} alt="COSMOS QR code" />
          </div>
        </div>

        <div className="footer__divider" />
        <div className="footer__brand">
          <img src={cosmosHome} alt="COSMOS" />
        </div>
      </div>

      <div className="footer__bottom">
        <span>{t('footer.copyright')}</span>
        <a
          className="footer__beian"
          href={ICP_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          {ICP_NUMBER}
        </a>
      </div>
    </footer>
  )
}

export default Footer
